// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import "firebase/auth";
import {
    connectFirestoreEmulator,
    initializeFirestore,
    persistentLocalCache,
    persistentMultipleTabManager,
    CACHE_SIZE_UNLIMITED,
} from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// https://firebase.google.com/docs/web/setup#available-libraries

// Firebase web configuration. These values are public identifiers (safe to
// ship in the client bundle), but can be overridden per-environment via
// REACT_APP_FIREBASE_* env vars so we don't hardcode a single project.
export const firebaseConfig = {
    apiKey:
        process.env.REACT_APP_FIREBASE_API_KEY ??
        "AIzaSyABfgIUmqBlEsdw7nALyMTDVcQGQjoyQ6s",
    authDomain:
        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ??
        "notatia-frontend.firebaseapp.com",
    projectId:
        process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "notatia-frontend",
    storageBucket:
        process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ??
        "notatia-frontend.appspot.com",
    messagingSenderId:
        process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "678172506284",
    appId:
        process.env.REACT_APP_FIREBASE_APP_ID ??
        "1:678172506284:web:e9f85b00e8c20118aa8709",
    measurementId:
        process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ?? "G-8QQXKKYM50",
};

const app = initializeApp(firebaseConfig);
const firestore = initializeFirestore(app, {
    localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
        cacheSizeBytes: CACHE_SIZE_UNLIMITED,
    }),
});
const firebaseAuth = getAuth(app);
const functions = getFunctions(app);
if (process.env.NODE_ENV === "development") {
    connectFirestoreEmulator(firestore, "localhost", 8080);
    connectAuthEmulator(firebaseAuth, "http://localhost:9099");
    connectFunctionsEmulator(functions, "localhost", 5001);
}
export const firebaseApps = {
    app: app,
    auth: firebaseAuth,
    firestore: firestore,
    functions: functions,
};

export default firebaseApps;
